export default __webpack_public_path__ + "static/media/gym.7af0d97a.svg";